export default {
	name:'loader',
	props:['loading'],
	watch: {
		loading:function(newVal,oldVal){
			//this.loading=newVal;
		}
	},
	methods:{
		
	}
}

